<script>
import { memberDetailsMethods } from '@state/helpers/member-details'
import BasicInfo from './details/basic-info.vue'
import Answer from './details/answer.vue'
import Note from './details/note.vue'
import History from './details/history.vue'
export default {
  components: { BasicInfo, Answer, Note, History },
  page: {
    title: 'Detail Member List Agent Admin Detail',
    meta: [
      {
        name: 'description',
        content: 'The Member List Agent Admin detail page.',
      },
    ],
  },
  data() {
    return {
      triggerMask: false,
    }
  },
  created() {
    this.getDetailMember()
    const user = this.$store.getters['auth/getCurrentUser']
    this.$router
      .replace({
        query: { agent_code: user?.agent?.agent_code },
      })
      .catch(() => {})
  },
  methods: {
    ...memberDetailsMethods,
    getDetailMember() {
      this.getDetailsById({
        id: parseInt(this.$route.params.id, 10),
        agent_id: parseInt(this.$route.params.agent_id, 10),
      })
    },
    handleTriggerMask(value) {
      this.triggerMask = value
    },
  },
}
</script>

<template>
  <div>
    <CRow>
      <CCol xl="4">
        <BasicInfo :trigger-mask="triggerMask" />
      </CCol>
      <CCol xl="4">
        <Answer :trigger-mask="triggerMask" />
      </CCol>
      <CCol xl="4">
        <Note :trigger-mask="triggerMask" @edit-note="handleTriggerMask" />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12">
        <History :trigger-mask="triggerMask"></History>
      </CCol>
    </CRow>
  </div>
</template>
